import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default values => ({
  cedeDate: values.cedeDate || momentLocalTimezone().add(1, 'month'),
  clientName: values.clientName || '',
  equipmentId: values.equipmentId || '',
  clientId: values.clientId || '',
  cededClientPersonType: values.cededClientPersonType || '',
  cededClientId: values.cededClientId || '',
  cededClientName: values.cededClientName || '',
  avals: values.avals || []
});
